import {
  settlementBuildingSpriteManifest,
  settlementDetailSpriteManifest as detail,
} from './game/asset-manifest';

const outcomes = {
  waterworks_canal: { building: 'garden', detail: detail.planter },
  waterworks_landing: { building: 'dock', detail: detail.canoe },
  archive_water: { building: 'codex_house', detail: detail.canoe },
  archive_sun: { building: 'codex_house', detail: detail.banner },
  garden_crop: { building: 'chinampa_farm', detail: detail.planter },
  garden_landscape: { building: 'garden', detail: detail.planter },
  observatory_solar: { building: 'solar_shrine', detail: detail.banner },
  observatory_rain: { building: 'solar_shrine', detail: detail.canoe },
} as const;

/** Shared preview and earned scene art. Never infer a completion from the selected artwork. */
export function CivicOutcomeArt({ variant }: { variant: string }) {
  const plan = outcomes[variant as keyof typeof outcomes];
  if (!plan) return null;
  const building = settlementBuildingSpriteManifest.find(
    (item) => item.buildingTypes.includes(plan.building) && item.stage === 'completed',
  );
  if (!building) return null;
  return (
    <>
      <img alt="" className="civic-city-outcome__building" src={building.url} />
      <img alt="" className="civic-city-outcome__detail" src={plan.detail.url} />
    </>
  );
}
